export default "__VITE_ASSET__RmrB2TGB__"